import { connect } from 'react-redux';

import { SidebarLegacyWrapper } from './SidebarLegacyWrapper/SidebarLegacyWrapper';
import type { Dispatch } from 'redux';

import type {
  AccessibleFleet,
  Location,
  Session,
} from '@cobliteam/common-types';

import type { WebData } from '@cobliteam/api-lib';

import {
  type AppState,
  changeUserFleetRequest,
  logoutRequest,
  selectAccessibleFleetsWebData,
  selectLocationPathname,
  selectLoginWebData,
} from '@cobliteam/store';

interface StateProps {
  loginWebData: WebData<Session>;
  currentLocation: Location;
  accessibleFleetsWebData: WebData<AccessibleFleet[]>;
}

interface DispatchProps {
  changeUserFleet: (fleet: AccessibleFleet) => void;
  logout: () => void;
}

const mapStateToProps = (state: AppState): StateProps => ({
  loginWebData: selectLoginWebData(state),
  accessibleFleetsWebData: selectAccessibleFleetsWebData(state),
  currentLocation: selectLocationPathname(state),
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  changeUserFleet: (fleet) => dispatch(changeUserFleetRequest(fleet)),
  logout: () => dispatch(logoutRequest()),
});

export default connect<StateProps, DispatchProps, {}, AppState>(
  mapStateToProps,
  mapDispatchToProps
)(SidebarLegacyWrapper);
